export default {
  container: ({ size }) => ({
    color: '#fff',
    animation: '0.3s slideUp',
    cursor: 'pointer',
    fontSize: size(1.6, { scaleFactor: 'sm' }),
    lineHeight: '1.2',
    display: 'flex',
    alignItems: 'center'
  }),
  icon: {
    width: '.7em',
    height: '.7em',
    marginRight: '.2em'
  },
  '@keyframes slideUp': {
    from: { opacity: '0', transform: 'translateY(20px)' },
    to: { opacity: '1', transform: 'translateY(0)' }
  }
}
